import { crud } from '../../libs/react-mpk/services';

let service = new crud('/table');
export default service;